export default __webpack_public_path__ + "static/media/CeraPro-Bold.0b089910.woff2";